import { render } from "./Main.vue?vue&type=template&id=47690bed"
const script = {}

import "./Main.vue?vue&type=style&index=0&id=47690bed&lang=scss"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__